import React from 'react';
import { loginURL } from '@/httpService/API';
const Privacy = () => {
    return (
        <div style={{ width: '100%', height: 'calc(100vh - 20px)' }}>
            <iframe style={{ height: '100%', width: '100%' }} src={`${loginURL}protocol`} frameborder="0"></iframe>
        </div>
    );
};

export default Privacy;
